module.exports = __webpack_public_path__ + "img/image04 (1).5fa98492.png";